import React from "react";

const BS5_Collapse = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Collapse Component</h2>
      <p>This is the BS5_Collapse component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Collapse;
